import React from 'react'
import * as styles from './closedBadge.css'
import { Badge } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import { isDetailsV1Dot1Enabled } from '../../../utils/features'

const ClosedBadge = () => {
  const useDetailV1Dot1 = isDetailsV1Dot1Enabled()
  const { getContent } = useLocalizedContent()

  return (
    <Badge
      type="neutral"
      contrast="low"
      className={styles.closedBadge}
      data-testid="closedBadge"
      aria-label={getContent('detail.closedPool')}
      tabIndex={0}
      {...(useDetailV1Dot1 ? {} : { size: 'small' })}
    >
      <Message id="poolsList.closed" />
    </Badge>
  )
}

export default ClosedBadge
